// React
import axios from "axios";
import { Dispatch, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as THREE from "three";
import { trads } from "../../datas/trads";
import getApiUrl from "../../utils/getApiUrl";
import Select from "react-select";
// CSS
import "./totem.css";
// Assets
import varsoViewImg from "../../style/assets/totems/varsoView.png";
import varsoCityImg from "../../style/assets/totems/varsoCity.png";
// Assets
import enFlag from "../../style/assets/flags/en.png";
import frFlag from "../../style/assets/flags/fr.png";
import deFlag from "../../style/assets/flags/de.png";
import esFlag from "../../style/assets/flags/es.png";
import nlFlag from "../../style/assets/flags/nl.png";
import plFlag from '../../style/assets/flags/pl.png';
import instagramWallMontparnasse from "../../style/assets/instagramWallMontparnasse.jpg";
import instagramWallBerlin from "../../style/assets/instagramWallBerlin.png";
import instagramWallChicago from "../../style/assets/instagramWallChicago.png";
import instagramWallRotterdam from "../../style/assets/instagramWallRotterdam.png";
import instagramWallVarsovie from "../../style/assets/instagramWallVarsovie.jpg";
import montparnasseMinia from "../../style/assets/montparnasseMinia.png";
import berlinMinia from "../../style/assets/berlinMinia.png";
import chicagoMinia from "../../style/assets/chicagoMinia.png";
import rotterdamMinia from "../../style/assets/rotterdamMinia.png";
import varsovieMinia from "../../style/assets/varsovieMinia.png";
import { setLanguage } from "../../actions/user";
import { useNavigate } from "react-router-dom";

export function Totem(props: {
	totem: any;
	cityDatas: any;
	assets: any;
	setCard: any;
	setVideo: any;
	changeOffsetAngle: any;
	setPoi: any;
	sphere: any;
	setPage: any;
	view3d: any;
	setViewer3d: any;
	movement: any;
	moveFinger: any;
	fingerTimeout: any;
	clearFinger: any;
}) {
	const navigate = useNavigate();
	const dispatch: Dispatch<any> = useDispatch();

	const { language, place, towerColor } = useSelector(
		(state: any) => state.user
	);

	const options = [
		{
			value: "en",
			label: "English",
			image: enFlag,
			places: ["montparnasse", "berlin", "chicago", "rotterdam", "varsovie"],
		},
		{ value: "fr", label: "French", image: frFlag, places: ["montparnasse"] },
		{ value: "de", label: "German", image: deFlag, places: ["berlin"] },
		{
			value: "nl",
			label: "Neetherlands",
			image: nlFlag,
			places: ["rotterdam"],
		},
		{ value: "es", label: "Español", image: esFlag, places: ["chicago"] },
		{ value: "pl", label: "Polski", image: plFlag, places: ["varsovie"] },
	];

	const setLang = (lang: string) => {
		dispatch(setLanguage(lang));
	};

	const [clickStatus, setClickStatus] = useState(false);
	const _clickStatus = useRef(clickStatus);

	useEffect(() => {
		_clickStatus.current = clickStatus;
	}, [clickStatus]);

	const _posStart = useRef<number[]>();
	const _pos = useRef<number[]>();

	const _v = useRef(); // Velocity

	const [loading, setLoading] = useState(true);
	const _loading = useRef(loading);

	useEffect(() => {
		_loading.current = loading;

		if (!loading) {
			let fingerElem = document.getElementById("finger");

			if (fingerElem) {
				fingerElem.style.opacity = "1";
				props.moveFinger();
			}

			props.fingerTimeout.current = setTimeout(() => {
				props.clearFinger();
			}, 4000);
		}
	}, [loading]);

	const [poi, setPoi] = useState<any>(null);

	useEffect(() => {
		let view = props.cityDatas.m3dmodels.find(
			(m: any) => m.short === props.totem
		);

		let poi = props.cityDatas.cards.find((c: any) => c.m3dmodel === view._id);

		if (poi) {
			setPoi(poi);
		} else {
			props.setPage("explorer");
		}

		let tmp = view.ffile.data.subffiles.find(
			(sf: any) => sf.status === "active" && sf.channel === "viewer3d"
		);
		let pathMovie = tmp.path;

		if (pathMovie) {
			let pathMovieFinal = pathMovie.split("\\")[1];
			if (!pathMovieFinal) {
				pathMovieFinal = pathMovie.split("/")[1];
			}

			let finalPathMovie =
				getApiUrl() + "/content/file/" + place + "/upload/" + pathMovieFinal;

			let movie = {
				url: finalPathMovie,
				size: tmp.size,
			};

			props.setViewer3d(movie);
		}
	}, []);

	// // TODO : REMOVE THIS CODE AND FIND INTERVAL PROBLEM
	// useEffect(() => {
	// 	// Get a reference to the last interval + 1
	// 	const interval_id = window.setInterval(function () {}, Number.MAX_SAFE_INTEGER);

	// 	// Clear any timeout/interval up to that id
	// 	for (let i = 1; i < interval_id - 2; i++) {
	// 		window.clearInterval(i);
	// 	}
	// 	window.clearInterval(interval_id);
	// }, []);

	function updateMovie(timestamp: number) {
		if (!_clickStatus.current) {
			/*let newV = 0;

			if (_v.current > 0.1) {
				newV = _v.current * 0.1;
			} else if (_v.current < 0) {
				newV = _v.current * -0.1;
			} else {
				newV = 0;
			}
			setV(newV);*/
		} else {
			if (_pos.current && _posStart.current) {
				let d = _pos.current[0] - _posStart.current[0];

				_posStart.current = [_pos.current[0], _pos.current[1]];

				let videoElem = document.getElementById(
					"videoViewer3DTotem"
				) as HTMLVideoElement;
				if (videoElem) {
					let currentTime = videoElem.currentTime;

					let newCurrentTime = currentTime - (d / timestamp) * 3000;

					while (newCurrentTime < 0) {
						newCurrentTime += videoElem.duration;
					}
					while (newCurrentTime > videoElem.duration) {
						newCurrentTime -= videoElem.duration;
					}

					videoElem.currentTime = newCurrentTime;
				}
			}
		}

		window.requestAnimationFrame(updateMovie);
	}

	useEffect(() => {
		if (props.view3d) {
			(async function () {
				await axios
					.get(props.view3d.url, {
						responseType: "blob",
						onDownloadProgress: (progressEvent) => {
							console.log(progressEvent);
							const current = progressEvent.loaded;

							let percentCompleted = Math.floor(
								(current / props.view3d.size) * 100
							);

							let elem = document.getElementById("viewer3DloadingAmountInside");

							if (elem) {
								elem.style.width = percentCompleted + "%";
							}
							console.log("completed: ", percentCompleted);
						},
					})
					.then((res) => {
						let myUrl = (window.URL || window.webkitURL).createObjectURL(
							res.data
						); // response.data.data

						let videoElem = document.getElementById(
							"videoViewer3DTotem"
						) as HTMLVideoElement;
						if (videoElem) {
							videoElem.src = myUrl;
							videoElem.setAttribute("type", res.headers["content-type"]);
							videoElem.load();
						}

						window.requestAnimationFrame(updateMovie);

						setLoading(false);

						return res.data;
					});
			})();
		} else {
			let view = props.cityDatas.m3dmodels.find(
				(m: any) => m.short === props.totem
			);

			let tmp = view.ffile.data.subffiles.find(
				(sf: any) => sf.status === "active" && sf.channel === "viewer3d"
			);
			let pathMovie = tmp.path;

			if (pathMovie) {
				let pathMovieFinal = pathMovie.split("\\")[1];
				if (!pathMovieFinal) {
					pathMovieFinal = pathMovie.split("/")[1];
				}

				let finalPathMovie =
					getApiUrl() + "/content/file/" + place + "/upload/" + pathMovieFinal;

				let movie = {
					url: finalPathMovie,
					size: tmp.size,
				};

				props.setViewer3d(movie);
			}
		}
	}, [props.view3d]);

	let towerName = "";
	let instagramWall;
	let followInstagram = "";

	let towers = [
		{
			id: "montparnasse",
			towerName: "Montparnasse",
			instagramWall: instagramWallMontparnasse,
			followInstagram: "@parismontparnasse.topofthecity",
			minia: montparnasseMinia,
		},
		{
			id: "berlin",
			towerName: language === "de" ? "Berliner Fernsehturm" : "TV Tower",
			instagramWall: instagramWallBerlin,
			followInstagram: "@Berliner_fernsehturm",
			minia: berlinMinia,
		},
		{
			id: "chicago",
			towerName: "360 chicago",
			instagramWall: instagramWallChicago,
			followInstagram: "@360CHICAGO",
			minia: chicagoMinia,
		},
		{
			id: "rotterdam",
			towerName: "Euromast",
			instagramWall: instagramWallRotterdam,
			followInstagram: "@euromast010",
			minia: rotterdamMinia,
		},
		{
			id: "varsovie",
			towerName: "Varso Tower",
			instagramWall: instagramWallVarsovie,
			followInstagram: "@varsotower_official",
			minia: varsovieMinia,
		},
	];

	switch (place) {
		case "montparnasse":
			towerName = "Montparnasse";
			instagramWall = instagramWallMontparnasse;
			followInstagram = "@parismontparnasse.topofthecity";
			break;
		case "berlin":
			towerName = language === "de" ? "Berliner Fernsehturm" : "TV Tower";
			instagramWall = instagramWallBerlin;
			followInstagram = "@Berliner_fernsehturm";
			break;
		case "chicago":
			towerName = "360 chicago";
			instagramWall = instagramWallChicago;
			followInstagram = "@360CHICAGO";
			break;
		case "rotterdam":
			towerName = "Euromast";
			instagramWall = instagramWallRotterdam;
			followInstagram = "@euromast010";
			break;
		case "varsovie":
			towerName = "Varso Tower";
			instagramWall = instagramWallVarsovie;
			followInstagram = "@varsotower_official";
	}

	const getInstaUrl = () => {
		switch (place) {
			case "montparnasse":
				return "https://instagram.com/parismontparnasse.topofthecity?igshid=wkh449ynhw67";
			case "berlin":
				return "https://instagram.com/berliner_fernsehturm?igshid=1l8u6pbcty13o";
			case "chicago":
				return "https://instagram.com/360chicago?utm_medium=copy_link";
			case "rotterdam":
				return "https://instagram.com/euromast010?utm_medium=copy_link";
			case "varsovie":
				return "#";
		}
	};

	return (
		<div
			className='totem-topContainer'
			style={{
				position: "absolute",
				top: "0px",
				height: "100dvh",
				backgroundColor: "#080d18", //"#090d18",
			}}
		>
			{/* <div className='city-lang' style={{ zIndex: 41000 }}>
				<Select
					id={"city-langSelection"}
					className={"city-langSelection"}
					classNamePrefix={"city-langSelection"}
					defaultValue={options[0]}
					value={options.filter((e) => e.value === language)[0]}
					options={options.filter((e) => e.places.includes(place))}
					isSearchable={false}
					formatOptionLabel={(country) => (
						<div className={"city-langOption"}>
							<div
								className='city-langFlag'
								style={{
									backgroundImage: "url(" + country.image + ")",
									backgroundSize: "cover",
									backgroundRepeat: "no-repeat",
									backgroundPosition: "center",
								}}
							></div>
							<div className={"city-langLang"}>{country.value}</div>
						</div>
					)}
					onChange={(e) => {
						if (e) {
							setLang(e.value);
						}
					}}
					menuPlacement={"auto"}
				/>
			</div> */}
			<div className='totem-title'>
				{trads.find((t) => t.id === language)?.totem3d}
				<div
					className='totem-subtitle'
					style={{
						backgroundColor: "#F9FAFB", //towerColor,
					}}
				>
					{poi?.name.translations.find((t: any) => t.langage === language)
						?.value || "Name"}
				</div>
			</div>
			<div
				className='tower-button clickable '
				style={{ position: "absolute", bottom: "40px", zIndex: 80000 }}
				onClick={(e: any) => {
					props.setPage("explorer");
					setTimeout(() => {
						if (poi) {
							props.setPoi(props.sphere.pois.find((p: any) => p.mcard === poi._id)?.short)
							props.setCard(poi._id);
						}
					}, 200);
				}}
			>
				<div className='tower-buttonText'>
					{trads.find((t) => t.id === language)?.knowMore}
				</div>
			</div>
			<div className='videoTotem-container'>
				<div
					className='totem-viewer3d'
					style={{
						height: "100%",
						backgroundColor: "#090d18",
					}}
				>
					{loading && (
						<div
							id='viewer3Dloading'
							className='viewer3Dloading'
							style={{
								color: "white",
								zIndex: "50000",
								top: "0px",
								left: "0px",
							}}
						>
							<div className='viewer3DloadingText'>
								{trads.find((t) => t.id === language)?.loading}
							</div>
							<div id='viewer3DloadingAmount' className='viewer3DloadingAmount'>
								<div
									id='viewer3DloadingAmountInside'
									className='viewer3DloadingAmountInside'
									style={{ backgroundColor: towerColor }}
								></div>
							</div>
						</div>
					)}
					<video
						id='videoViewer3DTotem'
						autoPlay
						playsInline
						width={window.innerWidth}
						height={window.innerHeight * 2}
						style={{
							height: "100%",
							width: "100%",
							objectFit: "cover",
							zIndex: "40000",
							backgroundColor: "#090d18",
						}}
						onMouseDown={(e: any) => {
							setClickStatus(true);

							let elem = document.getElementById(
								"videoViewer3DTotem"
							) as HTMLVideoElement;

							if (elem) {
								elem.pause();
							}

							_pos.current = [e.clientX, e.clientY];
							_posStart.current = [e.clientX, e.clientY];
						}}
						onTouchStart={(e: any) => {
							props.clearFinger();
							setClickStatus(true);
							let elem = document.getElementById(
								"videoViewer3DTotem"
							) as HTMLVideoElement;

							if (elem) {
								elem.pause();
							}
							_pos.current = [
								e.changedTouches[0].clientX,
								e.changedTouches[0].clientY,
							];
							_posStart.current = [
								e.changedTouches[0].clientX,
								e.changedTouches[0].clientY,
							];
						}}
						onMouseUp={(e: any) => {
							setClickStatus(false);
							//setPos([e.clientX, e.clientY]);
						}}
						onTouchEnd={(e: any) => {
							setClickStatus(false);
							//setPos([e.clientX, e.clientY]);
						}}
						onMouseMove={(e: any) => {
							_pos.current = [e.clientX, e.clientY];
						}}
						onTouchMove={(e: any) => {
							_pos.current = [
								e.changedTouches[0].clientX,
								e.changedTouches[0].clientY,
							];
						}}
					></video>
				</div>
				{/* <div style={{ height: "64px", width: "10px" }}></div> */}
			</div>
		</div>
	);
}
